"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RqlHelper {
    static EncodeSpecialCharactersForHttp(value) {
        if (value) {
            value = value.replaceAll('%', '%25');
            value = value.replaceAll('&', '%26');
            value = value.replaceAll('!', '%21');
            value = value.replaceAll('(', '%28');
            value = value.replaceAll(')', '%29');
            value = value.replaceAll('*', '%2A');
            value = value.replaceAll('=', '%3D');
            value = value.replaceAll(',', '%2C');
            value = value.replaceAll(';', '%3B');
            value = value.replaceAll('#', '%23');
        }
        return value;
    }
}
exports.default = RqlHelper;
